export const SEARCH_ADD_TO_CART = 'SEARCH_ADD_TO_CART'
export const SEARCH_REMOVE_FROM_CART = 'SEARCH_REMOVE_FROM_CART'
export const SEARCH_RESET_CART = 'SEARCH_RESET_CART'

//Get cart
export const GET_CART_REQUESTING = 'GET_CART_REQUESTING'
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS'
export const GET_CART_FAILED = 'GET_CART_FAILED'